import type { IFrontendServiceContainer } from '@phi/frontend/service-container';
import { ref } from 'vue';

export type SessionType =
    undefined
    | 'demo'
    | 'phi'
    | 'onshape'
    | 'local';

export type IAuthenticationState = ReturnType<typeof authentication_state_provider>;

export const authentication_state_provider = (app: IFrontendServiceContainer) => {
    const deviceStorage = app.device_storage;
    const showing_must_login_modal = ref(false);
    const session_type = ref<Set<SessionType>>(new Set());

    function show_must_login_modal() {
        showing_must_login_modal.value = true;
    }

    function hide_must_login_modal() {
        showing_must_login_modal.value = false;
    }

    /** returns whether the current user's session can be considered authorised */
    function is_authorised() {
        return (
            session_type.value.has('onshape')
            || session_type.value.has('phi')
        ) && deviceStorage.token !== undefined;
    }

    return {
        showing_must_login_modal,
        session_type,
        show_must_login_modal,
        hide_must_login_modal,
        is_authorised,
    };
};
